import React, { useContext, useEffect, useState, useMemo, useCallback } from 'react'
import { Header, HeaderButton, usePanels, useResizeGroup } from '@coherence-design-system/header';
import { ServiceContext } from '@msx/platform-services';
import { registerIcons } from '@fluentui/react/lib/Styling';
import { ProfileCenter } from '@coherence-design-system/profile-center';
import { Template } from '@coherence-design-system/slot';
import { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router-dom';
import { WhatsNew } from '../Announcements/Announcements';
import { announcementsData } from '../Announcements/announcementsData';
import {
  ContextualMenu,
  IPanel,
  ResizeGroup,
  Panel,
  Persona,
  PersonaSize,
  TooltipHost,
  DirectionalHint,
  IContextualMenuItem,
  ContextualMenuItemType,
  PanelType,
  PrimaryButton,
  Icon
} from '@fluentui/react';
import { HeaderProps, UNIVERSAL_TEMPLATETYPE, TemplateDetails } from "./AppHeader.types";
import { Help, Settings } from '..';
import { injectIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { getDismissedAnnouncements, setDismissedAnnouncements, setAppNavigationCollapsed } from '../../../core/store';
import { getStyles } from './AppHeader.style';
import coloredCopilot from '../../../app/images/coloredCopilot.svg';
import { AboutEcifWorkscope } from '../about/AboutEcif';
import { messages } from './AppHeader.messages';
import { DocumentArrowDown20Regular} from '@fluentui/react-icons';

import { CSTCopilot } from "../../../../node_modules/cst-web-chat/dist/cst-web-chat";
import "../../../../node_modules/cst-web-chat/dist/style.css";
import { agentSourceName, PRIVACY_LEGACY_URL } from '../../constant/constant';
import { FeedbackCenter } from '@coherence-design-system/feedback-center';
import {
  FeedbackAuthenticationType,
  FeedbackPolicyValue,
  FeedbackUiType,
  IFeedbackInitOptions
} from '@coherence-design-system/feedback-center';
import { CoherenceV9DarkTheme, CoherenceV9LightTheme } from '@coherence-design-system/styles';
import _ from 'lodash';
import { DataServiceContext } from '../../context';
import { TeachingBubbleMultiStep } from '../teachingBubble/TeachingBubble';
import { lStorageKey, Pathname } from '../teachingBubble/TeachingBubble.Type';
import { teachingBubbleData } from '../teachingBubble/teachingBubbleData';
import { IAnnouncementDetail, IAnnouncement } from '../../interfaces/IAnnouncemnet';
import { ICopilotConfig } from '../../interfaces';
import { FeedbackHostPlatformType } from '@coherence-design-system/controls';
import './AppHeader.css';

import { Resources } from '../resources/Resources';
import { customResourcePanelWidth } from '../resources/Resources.contsants';
import { toast } from 'react-toastify';
import { InsightData } from '../Insights/Insights';
import useCustomLogService from '../../services/useCustomLogService';

registerIcons({
  icons: {
    'configure-estimate': (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 6C3 4.34315 4.34315 3 6 3H14C15.6569 3 17 4.34315 17 6V9.59971C16.6832 9.43777 16.3486 9.30564 16 9.20703V7H4V14C4 15.1046 4.89543 16 6 16H9.20703C9.30564 16.3486 9.43777 16.6832 9.59971 17H6C4.34315 17 3 15.6569 3 14V6ZM12.0647 11.442C12.368 12.5231 11.722 13.642 10.6341 13.9199L10.173 14.0377C10.1581 14.1896 10.1504 14.3438 10.1504 14.4999C10.1504 14.6875 10.1615 14.8725 10.1831 15.0541L10.5326 15.1368C11.652 15.4014 12.318 16.5536 11.9887 17.6557L11.8623 18.0785C12.1195 18.2817 12.3993 18.4559 12.697 18.5964L13.022 18.2523C13.8118 17.416 15.1426 17.4167 15.9315 18.2538L16.2689 18.6118C16.5613 18.4769 16.8367 18.3095 17.0907 18.1142L16.9346 17.5575C16.6313 16.4764 17.2773 15.3575 18.3652 15.0795L18.8258 14.9619C18.8408 14.81 18.8484 14.6559 18.8484 14.4999C18.8484 14.3121 18.8373 14.127 18.8157 13.9452L18.4667 13.8627C17.3473 13.598 16.6813 12.4459 17.0106 11.3438L17.1368 10.9215C16.8796 10.7182 16.5998 10.5439 16.302 10.4034L15.9773 10.7472C15.1875 11.5835 13.8568 11.5828 13.0678 10.7457L12.7305 10.3877C12.438 10.5226 12.1626 10.6899 11.9086 10.8852L12.0647 11.442ZM14.4994 15.4999C13.9471 15.4999 13.4994 15.0521 13.4994 14.4999C13.4994 13.9476 13.9471 13.4999 14.4994 13.4999C15.0517 13.4999 15.4994 13.9476 15.4994 14.4999C15.4994 15.0521 15.0517 15.4999 14.4994 15.4999Z" fill="#212121" />
      </svg>
    ),
    'insights':(
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 3C3.89543 3 3 3.89543 3 5V15C3 16.1046 3.89543 17 5 17C6.10457 17 7 16.1046 7 15V5C7 3.89543 6.10457 3 5 3ZM4 5C4 4.44772 4.44772 4 5 4C5.55228 4 6 4.44772 6 5V15C6 15.5523 5.55228 16 5 16C4.44772 16 4 15.5523 4 15V5ZM8 8C8 6.89543 8.89543 6 10 6C11.1046 6 12 6.89543 12 8V15C12 16.1046 11.1046 17 10 17C8.89543 17 8 16.1046 8 15V8ZM10 7C9.44772 7 9 7.44772 9 8V15C9 15.5523 9.44772 16 10 16C10.5523 16 11 15.5523 11 15V8C11 7.44772 10.5523 7 10 7ZM13 11C13 9.89543 13.8954 9 15 9C16.1046 9 17 9.89543 17 11V15C17 16.1046 16.1046 17 15 17C13.8954 17 13 16.1046 13 15V11ZM15 10C14.4477 10 14 10.4477 14 11V15C14 15.5523 14.4477 16 15 16C15.5523 16 16 15.5523 16 15V11C16 10.4477 15.5523 10 15 10Z" fill="#0078D4"/>
     </svg>
    ),

    'estimate-summary': (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.25 3A2.75 2.75 0 0 1 21 5.75v12.5A2.75 2.75 0 0 1 18.25 21H5.75A2.75 2.75 0 0 1 3 18.25V5.75A2.75 2.75 0 0 1 5.75 3h12.5Zm0 1.5H5.75c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V5.75c0-.7-.56-1.25-1.25-1.25ZM7.75 9c.38 0 .7.28.74.64l.01.1v6.51a.75.75 0 0 1-1.5.1v-6.6c0-.42.34-.75.75-.75Zm8.5-2c.38 0 .7.27.74.63l.01.1v8.54c0 .4-.34.73-.75.73a.74.74 0 0 1-.74-.63l-.01-.1V7.73c0-.4.34-.73.75-.73Zm-4.27 5c.37 0 .67.26.73.62v.1l.04 3.54c0 .4-.32.73-.73.74a.73.73 0 0 1-.73-.62v-.1l-.04-3.55c0-.4.32-.73.73-.73Z" fill="#212121"></path>
      </svg>
    ),
    'compare-versions': (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.5 4.25194C12.5 3.73196 11.9837 3.36976 11.4948 3.54669L4.65454 6.02188C3.96161 6.27262 3.5 6.93056 3.5 7.66746V13.7491C3.5 14.2691 4.01625 14.6313 4.5052 14.4544L5 14.2753V15.8705C3.5378 16.388 2 15.3035 2 13.7491V7.66746C2 6.29894 2.85728 5.07704 4.14414 4.61138L10.9844 2.1362C12.4512 1.60541 14 2.69202 14 4.25194V4.42895L12.5 4.97174V4.25194ZM16.5 7.25194C16.5 6.73196 15.9837 6.36976 15.4948 6.54669L8.32467 9.14124C7.82972 9.32034 7.5 9.7903 7.5 10.3167V16.7491C7.5 17.2691 8.01625 17.6313 8.5052 17.4544L9 17.2753V18.8705C7.5378 19.388 6 18.3035 6 16.7491V10.3167C6 9.15868 6.72539 8.12477 7.81427 7.73075L14.9844 5.1362C16.4512 4.60541 18 5.69202 18 7.25194V7.42895L16.5 7.97174V7.25194ZM19.4948 9.54667C19.9837 9.36975 20.5 9.73195 20.5 10.2519V17.0352C20.5 17.351 20.3022 17.633 20.0052 17.7404L12.5052 20.4544C12.0163 20.6313 11.5 20.2691 11.5 19.7491V12.9658C11.5 12.65 11.6978 12.368 11.9948 12.2606L19.4948 9.54667ZM22 10.2519C22 8.692 20.4512 7.60539 18.9844 8.13618L11.4844 10.8501C10.5935 11.1725 10 12.0184 10 12.9658V19.7491C10 21.309 11.5488 22.3956 13.0156 21.8649L20.5156 19.1509C21.4065 18.8286 22 17.9826 22 17.0352V10.2519Z" fill="#212121" />
      </svg>
    ),
    'help-icon': (
      <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 15H5V16H4V15ZM4.5 0C4.91146 0 5.30729 0.0546875 5.6875 0.164062C6.07292 0.268229 6.43229 0.419271 6.76562 0.617188C7.09896 0.809896 7.40365 1.04427 7.67969 1.32031C7.95573 1.59635 8.1901 1.90104 8.38281 2.23438C8.58073 2.56771 8.73177 2.92708 8.83594 3.3125C8.94531 3.69271 9 4.08854 9 4.5C9 4.9375 8.94271 5.33333 8.82812 5.6875C8.71354 6.04167 8.5625 6.36719 8.375 6.66406C8.1875 6.95573 7.97396 7.22656 7.73438 7.47656C7.49479 7.72656 7.25 7.96875 7 8.20312C6.75 8.4375 6.50521 8.67188 6.26562 8.90625C6.02604 9.13542 5.8125 9.38021 5.625 9.64062C5.4375 9.90104 5.28646 10.1823 5.17188 10.4844C5.05729 10.7865 5 11.125 5 11.5V13H4V11.5C4 11.0625 4.05729 10.6667 4.17188 10.3125C4.28646 9.95833 4.4375 9.63542 4.625 9.34375C4.8125 9.04688 5.02604 8.77604 5.26562 8.53125C5.50521 8.28125 5.75 8.03906 6 7.80469C6.25 7.57031 6.49479 7.33594 6.73438 7.10156C6.97396 6.86719 7.1875 6.61979 7.375 6.35938C7.5625 6.09896 7.71354 5.81771 7.82812 5.51562C7.94271 5.21354 8 4.875 8 4.5C8 4.01562 7.90625 3.5625 7.71875 3.14062C7.53646 2.71354 7.28646 2.34375 6.96875 2.03125C6.65625 1.71354 6.28646 1.46354 5.85938 1.28125C5.4375 1.09375 4.98438 1 4.5 1C4.01562 1 3.5599 1.09375 3.13281 1.28125C2.71094 1.46354 2.34115 1.71354 2.02344 2.03125C1.71094 2.34375 1.46094 2.71354 1.27344 3.14062C1.09115 3.5625 1 4.01562 1 4.5H0C0 4.08854 0.0520833 3.69271 0.15625 3.3125C0.265625 2.92708 0.416667 2.56771 0.609375 2.23438C0.807292 1.90104 1.04427 1.59635 1.32031 1.32031C1.59635 1.04427 1.90104 0.809896 2.23438 0.617188C2.56771 0.419271 2.92448 0.268229 3.30469 0.164062C3.6901 0.0546875 4.08854 0 4.5 0Z" fill="white" />
      </svg>
    ),
    'raise-support-ticket': (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M4 8C4 4.68629 6.68629 2 10 2C13.3137 2 16 4.68629 16 8V11C16 12.1046 15.1046 13 14 13H13C12.4477 13 12 12.5523 12 12V9C12 8.44772 12.4477 8 13 8H15C15 5.23858 12.7614 3 10 3C7.23858 3 5 5.23858 5 8H7C7.55228 8 8 8.44772 8 9V12C8 12.5523 7.55228 13 7 13H5V14C5 15.1046 5.89543 16 7 16H8C8 14.8954 8.89543 14 10 14C11.1046 14 12 14.8954 12 16C12 17.1046 11.1046 18 10 18C9.25972 18 8.61337 17.5978 8.26756 17H7C5.34315 17 4 15.6569 4 14V8ZM15 9H13V12H14C14.5523 12 15 11.5523 15 11V9ZM5 12H7V9H5V12ZM9 16C9 16.5523 9.44772 17 10 17C10.5523 17 11 16.5523 11 16C11 15.4477 10.5523 15 10 15C9.44772 15 9 15.4477 9 16Z" fill="#0078D4" />
      </svg>),
    'whatsNew': (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M18 4.8016C18 3.81605 17.0658 3.09831 16.1135 3.35225L3.11351 6.81891C2.45688 6.99402 2 7.58869 2 8.26827V10.7792C2 11.4249 2.41315 11.9981 3.02566 12.2023L5 12.8604V13.75C5 15.5449 6.45507 17 8.25 17C9.62112 17 10.7932 16.1513 11.2709 14.9507L16.0257 16.5356C16.997 16.8594 18 16.1364 18 15.1126V4.8016ZM10.32 14.6337C9.97657 15.437 9.17866 16 8.25 16C7.00736 16 6 14.9926 6 13.75V13.1937L10.32 14.6337ZM16.3712 4.31848C16.6886 4.23384 17 4.47309 17 4.8016V15.1126C17 15.4538 16.6657 15.6948 16.3419 15.5869L3.34189 11.2536C3.13771 11.1855 3 10.9944 3 10.7792V8.26827C3 8.04174 3.15229 7.84352 3.37117 7.78515L16.3712 4.31848Z" fill="#0078D4" />
      </svg>),
    'guided-tour': (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M8.78197 8.28958L8.09689 2.80623C8.01728 2.16938 8.46901 1.58858 9.10586 1.50897L9.17779 1.50225L9.34598 1.5C9.94193 1.5 10.4814 1.85279 10.7202 2.39879L13.2322 8.14109L15.9842 8.05025C17.012 8.01599 17.8807 8.7833 17.9887 9.78967L17.9989 9.93501L18 10C18 11.0774 17.1266 11.9508 16.0408 11.9508L13.2332 11.858L10.7202 17.6012C10.4814 18.1472 9.94193 18.5 9.34598 18.5H9.25C8.6082 18.5 8.08791 17.9797 8.08791 17.3379C8.08791 17.2897 8.09091 17.2416 8.09688 17.1938L8.78198 11.7094L6.63962 11.6378L5.68219 13.3139C5.43977 13.7382 4.98862 14 4.5 14C3.94772 14 3.5 13.5523 3.5 13V11.5336L3.33875 11.5215C2.58109 11.4252 2 10.7786 2 10C2 9.22141 2.58109 8.57483 3.33792 8.47851L3.5 8.46635V7C3.5 6.44772 3.94772 6 4.5 6C4.98862 6 5.43977 6.26181 5.68218 6.68603L6.63955 8.36121L8.78197 8.28958ZM9.34598 2.5L9.2299 2.50125C9.14107 2.51236 9.07806 2.59336 9.08917 2.68222L9.91004 9.25242L6.07045 9.38079L4.81395 7.18219C4.74957 7.06953 4.62976 7 4.5 7V9.43165L3.5161 9.46641C3.22833 9.476 3 9.71206 3 10C3 10.2879 3.22833 10.524 3.5161 10.5336L4.5 10.5664V13L4.5763 12.9919C4.67546 12.9705 4.76244 12.908 4.81391 12.8179L6.07038 10.6182L9.91002 10.7466L9.08791 17.3379C9.08791 17.4274 9.16048 17.5 9.25 17.5H9.34598C9.54463 17.5 9.72444 17.3824 9.80407 17.2004L12.5888 10.836L16.0492 10.9508C16.5743 10.9508 17 10.5251 17 10L16.9995 9.96832C16.982 9.44348 16.5423 9.0322 16.0173 9.0497L12.5878 9.16291L9.80406 2.79959C9.72444 2.6176 9.54463 2.5 9.34598 2.5Z" fill="#0078D4" />
      </svg>),
    'roadmap': (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.7309 3.05651C17.8963 3.14261 18 3.31356 18 3.5V13C18 13.1632 17.9204 13.3161 17.7867 13.4096L12.7867 16.9096C12.6146 17.0301 12.3854 17.0301 12.2133 16.9096L7.5 13.6103L2.78673 16.9096C2.634 17.0165 2.43446 17.0296 2.26909 16.9435C2.10373 16.8574 2 16.6864 2 16.5V7C2 6.83684 2.07961 6.68395 2.21327 6.59039L7.21327 3.09039C7.38543 2.96987 7.61457 2.96987 7.78673 3.09039L12.5 6.38967L17.2133 3.09039C17.366 2.98347 17.5655 2.97041 17.7309 3.05651ZM12 7.26033L8 4.46033V12.7397L12 15.5397V7.26033ZM13 15.5397L17 12.7397V4.46033L13 7.26033V15.5397ZM7 12.7397V4.46033L3 7.26033V15.5397L7 12.7397Z" fill="#0078D4" />
      </svg>
    ),
    'privacy-notice': (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M6 6C6 3.79086 7.79086 2 10 2C11.2632 2 12.3896 2.58554 13.1227 3.5H10V3C8.34315 3 7 4.34315 7 6C7 7.65685 8.34315 9 10 9V8.5H13.1227C12.3896 9.41446 11.2632 10 10 10C7.79086 10 6 8.20914 6 6ZM13.7092 7.5H10V6.5H13.9691C13.9255 6.84932 13.8369 7.18466 13.7092 7.5ZM13.9691 5.5C13.9255 5.15068 13.8369 4.81535 13.7092 4.5H10V5.5H13.9691ZM3 13C3 11.8869 3.90315 11 5.00873 11L15 11C15.7383 11 16.3832 11.4002 16.7297 11.9954H10V12L5.00873 12C4.44786 12 4 12.4467 4 13C4 14.3088 4.62226 15.2837 5.67262 15.9534C6.74318 16.636 8.26489 17 10 17L14.5208 17C13.2816 17.6782 11.6935 18 10 18C8.14526 18 6.41697 17.614 5.13499 16.7966C3.83281 15.9663 3 14.6912 3 13ZM10 13.9954V12.9954H17L17 13C17 13.3497 16.9644 13.6815 16.8964 13.9954L10 13.9954ZM16.5437 14.9954C16.3577 15.364 16.1191 15.6991 15.8359 16H14.2528C14.2553 15.9985 14.2578 15.9969 14.2604 15.9954H10V14.9954H16.5437Z" fill="#0078D4" />
      </svg>),
    'business-support': (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M9.25028 7.30723C9.08872 7.49072 9.00001 7.74463 9.00001 8C9.00001 8.27614 8.77615 8.5 8.50001 8.5C8.22387 8.5 8.00001 8.27614 8.00001 8C8.00001 7.52689 8.1613 7.0308 8.49974 6.64641C8.84684 6.25219 9.3597 6 10 6C10.6403 6 11.1532 6.25219 11.5003 6.64641C11.8387 7.0308 12 7.52689 12 8C12 8.48947 11.8839 8.86964 11.6976 9.18921C11.5347 9.46855 11.3225 9.68963 11.1528 9.86652L11.1115 9.90956C10.9247 10.1051 10.7821 10.2639 10.6773 10.4641C10.5773 10.6551 10.5 10.9085 10.5 11.2929C10.5 11.5691 10.2762 11.7929 10 11.7929C9.72387 11.7929 9.50001 11.5691 9.50001 11.2929C9.50001 10.7611 9.61018 10.3464 9.79143 10.0002C9.96788 9.66319 10.2003 9.41576 10.3885 9.21878L10.4106 9.19559C10.5985 8.99908 10.7328 8.85858 10.8337 8.68547C10.9286 8.52273 11 8.31707 11 8C11 7.74463 10.9113 7.49072 10.7497 7.30723C10.5968 7.13358 10.3597 7 10 7C9.64033 7 9.40318 7.13358 9.25028 7.30723ZM9.99991 14.2122C10.3863 14.2122 10.6995 13.899 10.6995 13.5126C10.6995 13.1262 10.3863 12.813 9.99991 12.813C9.61353 12.813 9.3003 13.1262 9.3003 13.5126C9.3003 13.899 9.61353 14.2122 9.99991 14.2122ZM2.00001 10C2.00001 5.58172 5.58173 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C8.65078 18 7.37829 17.6656 6.26225 17.0748L2.62128 17.9851C2.45089 18.0277 2.27065 17.9777 2.14646 17.8536C2.02227 17.7294 1.97234 17.5491 2.01494 17.3787L2.92518 13.7378C2.33442 12.6217 2.00001 11.3492 2.00001 10ZM10 3C6.13402 3 3.00001 6.13401 3.00001 10C3.00001 11.245 3.32462 12.4128 3.89345 13.4247C3.95602 13.536 3.97363 13.6671 3.94266 13.791L3.18719 16.8128L6.20904 16.0574C6.33294 16.0264 6.46399 16.044 6.57531 16.1066C7.58726 16.6754 8.75497 17 10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3Z" fill="#0078D4" />
      </svg>
    ),
    'mcaps-help': (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 15.9644L11.7266 13.8286C11.3255 13.9222 10.9166 13.9689 10.5 13.9689C9.98437 13.9689 9.48437 13.8988 9 13.7584C8.51563 13.6182 8.05989 13.4207 7.6328 13.1661C7.20571 12.9114 6.82032 12.597 6.47659 12.2228C6.1328 11.8487 5.84112 11.4329 5.60155 10.9756C5.3776 10.9756 5.15625 10.9652 4.9375 10.9444C4.71875 10.9237 4.5 10.8873 4.28125 10.8353L0 12.9711L1.74219 9.4868C1.1849 8.96711 0.755211 8.3617 0.453125 7.67056C0.151042 6.97942 0 6.25188 0 5.48794C0 4.98389 0.065104 4.498 0.195313 4.0303C0.325521 3.5626 0.510417 3.12608 0.75 2.72074C0.989584 2.3154 1.27604 1.94384 1.60938 1.60606C1.94271 1.26828 2.3125 0.98246 2.71875 0.748607C3.125 0.514758 3.5651 0.330277 4.03906 0.195163C4.51302 0.0600502 5 -0.00490796 5.5 0.000288704C6.01563 0.000288704 6.51563 0.0704434 7 0.210753C7.48437 0.351063 7.94011 0.548539 8.3672 0.803172C8.79429 1.05781 9.17968 1.37221 9.52341 1.74637C9.8672 2.12053 10.1589 2.53626 10.3985 2.99356C10.9141 2.99356 11.4089 3.05593 11.8828 3.18065C12.3567 3.30537 12.8021 3.48725 13.2188 3.7263C13.6354 3.96534 14.013 4.24596 14.3516 4.56816C14.6901 4.89035 14.9844 5.25671 15.2344 5.66727C15.4844 6.07776 15.6719 6.51949 15.7969 6.9924C15.9219 7.46531 15.9896 7.96159 16 8.48122C16 9.24516 15.849 9.9727 15.5469 10.6638C15.2448 11.355 14.8151 11.963 14.2578 12.4878L16 15.9644ZM11 11.9734V10.9756H10V11.9734H11ZM4.25 9.8064C4.40625 9.84275 4.5625 9.87654 4.71875 9.90772C4.875 9.9389 5.03646 9.95971 5.20313 9.97009C5.06771 9.47642 5 8.9801 5 8.48122C5 7.83685 5.10677 7.22106 5.32031 6.63385C5.53387 6.04658 5.83072 5.51657 6.21093 5.04365C6.59115 4.57075 7.04688 4.16541 7.57813 3.82763C8.10939 3.48985 8.69008 3.2534 9.32032 3.11829C9.112 2.79089 8.86981 2.49729 8.59376 2.23745C8.31771 1.97762 8.01301 1.75416 7.67968 1.56708C7.34635 1.38 7 1.23969 6.64064 1.14615C6.28123 1.05261 5.90107 1.00325 5.5 0.998046C4.88021 0.998046 4.29688 1.11497 3.75 1.34882C3.20313 1.58267 2.72656 1.90486 2.32031 2.3154C1.91406 2.72594 1.59375 3.20143 1.35938 3.74188C1.125 4.28234 1.00521 4.86437 1 5.48794C1 6.12193 1.12239 6.71697 1.36719 7.273C1.61198 7.82908 1.96614 8.32536 2.42969 8.76187L2.97656 9.26852C2.85677 9.51798 2.73437 9.76223 2.60938 10.0013C2.48437 10.2403 2.35938 10.4872 2.23437 10.7418L4.15625 9.78299L4.25 9.8064ZM9.5 6.98458C9.5 6.84431 9.52603 6.71436 9.57813 6.59484C9.63019 6.47532 9.70053 6.3714 9.78907 6.28306C9.8776 6.19473 9.98437 6.12193 10.1094 6.06478C10.2344 6.00763 10.3646 5.98166 10.5 5.98682C10.6406 5.98682 10.7708 6.01284 10.8906 6.06478C11.0104 6.11677 11.1146 6.1869 11.2031 6.27524C11.2917 6.36363 11.3646 6.47011 11.4219 6.59484C11.4791 6.71957 11.5052 6.84947 11.5 6.98458C11.5 7.13528 11.4635 7.27044 11.3906 7.38996C11.3177 7.50948 11.2266 7.62639 11.1172 7.74069C11.0078 7.85505 10.8854 7.96935 10.75 8.08371C10.6146 8.19801 10.4948 8.32796 10.3906 8.47345C10.2865 8.61894 10.1927 8.78262 10.1094 8.96451C10.026 9.14639 9.9896 9.35946 10 9.60371V9.97786H11V9.74403C11 9.60893 11.0104 9.48158 11.0313 9.36207C11.0521 9.24255 11.1172 9.12824 11.2266 9.0191C11.3828 8.86319 11.5365 8.71509 11.6875 8.57477C11.8386 8.4345 11.9766 8.28374 12.1015 8.12266C12.2266 7.96159 12.3229 7.79268 12.3906 7.61601C12.4583 7.43929 12.4948 7.22883 12.5 6.98458C12.5 6.7092 12.4479 6.45196 12.3437 6.21287C12.2396 5.97384 12.0964 5.76077 11.9141 5.57372C11.7318 5.38662 11.5209 5.24372 11.2812 5.14498C11.0417 5.04625 10.7812 4.99428 10.5 4.98908C10.2239 4.98908 9.96613 5.04105 9.72656 5.14498C9.48699 5.24892 9.27344 5.39184 9.08592 5.57372C8.89845 5.75561 8.7552 5.96607 8.65627 6.2051C8.55728 6.44414 8.50523 6.70398 8.5 6.98458H9.5Z" fill="#0078D4" />
      </svg>
    ),
    'walking-deck': (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
        <path fill="none" d="M3.5 15h13c.267 0 .5-.162.5-.346V8h-2.5c-.827 0-1.5-.673-1.5-1.5V5H3.5c-.267 0-.5.162-.5.346v9.308c0 .184.233.346.5.346Z"/><path fill="#fff" d="M16.638 7 14.01 5.157c-.003-.003-.007-.003-.01-.006V6.5a.5.5 0 0 0 .5.5h2.138Z"/><path fill="#0078D4" fill-rule="evenodd" d="M17.494 6.381 14.62 4.366c-.29-.24-.654-.37-1.03-.366H3.5C2.673 4 2 4.604 2 5.346v9.308C2 15.396 2.673 16 3.5 16h13c.827 0 1.5-.604 1.5-1.346V7.39c0-.37-.17-.727-.506-1.008Zm-.856.62H14.5a.5.5 0 0 1-.5-.5V5.15l.005.003c.002 0 .003.002.005.003L16.638 7ZM3.5 15h13c.267 0 .5-.163.5-.347V8h-2.5c-.827 0-1.5-.673-1.5-1.5V5H3.5c-.267 0-.5.162-.5.346v9.308c0 .184.233.346.5.346Z" clip-rule="evenodd"/><path fill="#0078D4" fill-rule="evenodd" d="M8.5 9h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1Zm0 2h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1Zm-4 2h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0 0 1Z" clip-rule="evenodd"/><path fill="#0078D4" d="M13 9a1 1 0 0 1 1 1h-1V9Z"/><path fill="#0078D4" d="M14 11a2.002 2.002 0 0 1-3.955.432A2.002 2.002 0 0 1 12 9v2h2Z"/>
      </svg>
    )

  },
});
let classes: any;

type Props = HeaderProps & RouteComponentProps;
const AppHeaderComponent: React.FC<Props> = ({ appName, theme, user, intl, isAppReady, isUserLoggedIn, history, appNameTooltip }) => {
  //const categorizedNotifications = getCategorizedNotifications(theme);
  classes = getStyles(theme)
  //const [searchText, setSearchText] = React.useState('');
  const context = React.useContext(ServiceContext)
  const reduxDispatch = useDispatch();
  const profileCenterRef = React.useRef<IPanel>(null);
  //const notificationCenterRef = React.useRef<IPanel>(null);
  const settingsPanelRef = React.useRef<IPanel>(null);
  const { currentPanel, openPanel, closePanel } = usePanels();
  const signoutBtnRef = React.useRef<HTMLButtonElement>(null);
  const [isBotOpen, setIsBotOpen] = useState(window?.location?.pathname?.includes(Pathname.DASHBOARD));
  const aboutPanelRef = React.useRef<IPanel>(null);
  const feedbackCenterRef = React.useRef<IPanel>(null);
  const [bubbleEnabled, setBubbleEnabled] = useState(false);
  const [hideTourPopup, setHideTourPopup] = useState(true);
  const [shouldSetTBData, setShouldSetTBData] = useState(false);
  const [teachingBubbleVisible, setTeachingBubbleVisible] = useState(false);
  const [copilotConfig, setCopilotConfig] = useState<ICopilotConfig>({
    copilotWelcomeMessage: intl.formatMessage(messages.copilotWelcomeMessage),
    copilotWelcomeSuggestion: intl.formatMessage(messages.copilotWelcomeSuggestion),
    copilotPromptsSuggestions: intl.formatMessage(messages.copilotPromptsSuggestions),
    CopilotCustomerYield: intl.formatMessage(messages.copilotCustomerYield),
    SupportTicketPrompt: {
      Enabled: false,
      Message: "Create Support ticket"
    }
  });
  const [routePathname, setRoutePathname] = useState('');
  const dismissedAnnouncements = useSelector(getDismissedAnnouncements)
  const [openedThroughMenu, setOpenedThroughMenu] = useState(false)
  const [filteredAnnouncements, setfilteredAnnouncements] = useState<IAnnouncementDetail[]>([])
  const [hideDialog, setHideDialog] = useState(true);
  const [announcementJsondata, setannouncementJsondata] = useState<IAnnouncement>({} as IAnnouncement);

  const [isResourcePanelOpen, setIsResourcePanelOpen] = useState(false);
  const [supplierTemplateVersions, setSupplierTemplateVersions] = useState <TemplateDetails[]>([])
  const [showWhatsNew, setShowWhatsNew] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const resourceUrlParam = urlParams.get('resources') === 'true';

  const [externalMessage, setExternalMessage] = useState({
    handleSendMessage: null,
    enabled: false,
    isInit: false,
    isSupportTicketClicked: false
  });
  const [isHelpMenuOpen, setIsHelpMenuOpen] = useState(false);
  const [helpMenuTarget, setHelpMenuTarget] = useState<HTMLElement | null>(null);
  useEffect(() => {
    if(resourceUrlParam){
      getTemplateVersion();
      setIsBotOpen(false);
      setIsResourcePanelOpen(true);
    }
  }, [resourceUrlParam]);

  const { dataService } = useContext(DataServiceContext);
  const showWhatsNewBasedonAdditionalCondition = (localStorage?.getItem(intl.formatMessage(messages.competitiveBidProperty)) === intl.formatMessage(messages.ECIFProjectIsNotCompetitiveBid) || window.location.pathname?.includes(Pathname.DASHBOARD)) ? true : false;

  const handleTeachingBubbleClicked = useCallback(() => {
    setBubbleEnabled(!bubbleEnabled);
  }, [bubbleEnabled]);

  const closeTeachingBubble = useCallback(() => {
    const isDashboardFlow = window.location.pathname?.includes(Pathname.DASHBOARD);
    if (teachingBubbleVisible && isDashboardFlow) {
      setTeachingBubbleVisible(false);
      localStorage.setItem(lStorageKey.SGT, "false");
    }
  }, [teachingBubbleVisible,  window?.location?.pathname]);

  const { trackCustomEvents } = useCustomLogService();

  const filterAndSort = useCallback((announcements) => {
    return announcements.filter(
      announcement => {
        const startDate = new Date(announcement.startDate);
        const endDate = new Date(announcement.endDate);
        let currentDate = new Date()
        return endDate > currentDate && startDate <= currentDate;
      })
      .sort((a, b) => {
        const dateA = new Date(a.startDate).getTime();
        const dateB = new Date(b.startDate).getTime();
        return dateB - dateA;
      })
  }, []);

  const showGuidedTour = useCallback(() => {
    closeTeachingBubble();
    let teachingBubble = Object.assign(
      {},
      JSON.parse(localStorage.getItem(lStorageKey.TEACHING_BUBBLE))
    );
    if (window.location.pathname?.includes(Pathname.DASHBOARD)) {
      if (teachingBubble?.dashboard) {
        const data = { ...teachingBubble, dashboard: false };
        localStorage.setItem(lStorageKey.TEACHING_BUBBLE, JSON.stringify(data));
      }
      {
        setHideTourPopup(true);
        setBubbleEnabled(true);
      }
    } else if (window.location.pathname?.includes(Pathname.ECIF_WORKSCOPE)) {
      if (teachingBubble?.ecifWorkscope) {
        const data = { ...teachingBubble, ecifWorkscope: false };
        localStorage.setItem(lStorageKey.TEACHING_BUBBLE, JSON.stringify(data));
      }
      setBubbleEnabled(true);
    }
  }, [closeTeachingBubble, setBubbleEnabled, window?.location?.pathname]);

  const getTemplateVersion = useCallback(() => {
    if(supplierTemplateVersions.length === 0){
      const templateTypes : string[] = [UNIVERSAL_TEMPLATETYPE.NONEXEMPT, UNIVERSAL_TEMPLATETYPE.EXEMPT]
      templateTypes.map(templateType => {
        dataService
        ?.SupplierTemplateVersion(templateType)
        ?.then(version => {
          if(version){
            setSupplierTemplateVersions(prevValue => [...prevValue, { templateType, version }])
          }
        })
        ?.catch(() => toast.error(intl.formatMessage(messages.templateVersionFailedMessage)))
      })
    }
  }, [supplierTemplateVersions, dataService]);

  useEffect(() => Array.from(document.querySelectorAll('div'))?.find(div => div.ariaLabel === intl.formatMessage(messages.competitiveBid)) && setTeachingBubbleVisible(false));

  useEffect(() => {
    const data = announcementsData as unknown as IAnnouncement;
    setannouncementJsondata(data);
    const dismissedIds = (dismissedAnnouncements || []).map((dismissed) => dismissed.id);
    const activeAnnouncements = filterAndSort(data.Announcements).filter(
      (announcement) => !dismissedIds.includes(announcement.id)
    );
    setfilteredAnnouncements(activeAnnouncements);
  }, [filterAndSort, dismissedAnnouncements])

  useEffect(() => {
    if (isUserLoggedIn && filteredAnnouncements?.length > 0) {
     setHideDialog(false);
    }
  }, [isUserLoggedIn, openedThroughMenu, filteredAnnouncements])


  useEffect(() => {
    if (bubbleEnabled)
      setIsBotOpen(false);
  }
    , [bubbleEnabled])

  const toggleHideDialog = useCallback((dontShowAgain: boolean) => {
    if (dontShowAgain) {
      const tempDismissAnnounceMents = [...dismissedAnnouncements];
      announcementJsondata.Announcements.forEach((val) => {
        let status = tempDismissAnnounceMents.some(function(el) {
          return (el.id === val.id);
        });
        if (!status) {
          tempDismissAnnounceMents.push({ id: val.id, expiryDate: val.endDate });
        }
      });

      reduxDispatch(
        setDismissedAnnouncements(
          tempDismissAnnounceMents.filter(
            (announcement) => new Date(announcement.expiryDate) > new Date()
          )
        )
      );
      localStorage.setItem(
        "dismissedAnnouncements",
        JSON.stringify(tempDismissAnnounceMents)
      );
      setShowWhatsNew(false);
    }
    setHideDialog(!hideDialog);
    setShowWhatsNew(false);
  }, [hideDialog, dismissedAnnouncements, announcementJsondata, setShowWhatsNew]);

  const trackHelpMenuOptionClicks = useCallback((option: string) => {
    trackCustomEvents(`ECIFWorkscopePortal.Help.${option}`,  `${intl.formatMessage(messages[option])} Button Click`, 'Success');
  }, [trackCustomEvents, intl]);

  const handleWhatsNewClicked = useCallback(() => {
    closeTeachingBubble(); // this is required to close teaching bubble on click of any item in help menu
    //call end point for announcement data
    setOpenedThroughMenu(true)
    const filteredAnnouncements = filterAndSort(announcementJsondata.Announcements)
    setfilteredAnnouncements(filteredAnnouncements)
    setShowWhatsNew(true);
    setHideDialog(false);
    trackHelpMenuOptionClicks('whatsNew');
  }, [closeTeachingBubble, filterAndSort, announcementJsondata, trackHelpMenuOptionClicks, setShowWhatsNew]);

  const helpSubMenuItems: IContextualMenuItem[] = useMemo(() =>[
    // Temporarily hidden per request (2026-07-31) — keep for possible re-enable later.
    // {
    //   key: "mcapshelp",
    //   text: intl.formatMessage(messages.mcapshelp),
    //   ariaLabel: intl.formatMessage(messages.mcapshelp),
    //   iconProps: { iconName: "mcaps-help" },
    //   href: "https://aka.ms/ecifwsmcapshelp",
    //   target: "https://aka.ms/ecifwsmcapshelp",
    //   onClick: () => {
    //     closeTeachingBubble();
    //     trackHelpMenuOptionClicks('mcapshelp');
    //   }
    // },
    // Changes made by Raviteja Madhira - 2026-07-31 - ADO 16480330: Help relocated
    // out of the Deal Assistance white command ribbon into this blue-bar `?` menu.
    // Surfaces the same troubleshooting tip + support aliases the ribbon Help used
    // to raise (UDAAppHeaderMoreInfoBtn parity). Renders in embedded mode too.
    {
      key: "dealAssistanceSupport",
      text: "Deal Assistance support",
      ariaLabel: "Deal Assistance support",
      iconProps: { iconName: "Headset" },
      subMenuProps: {
        items: [
          {
            key: "daHardReset",
            text: "Experiencing issues? Clear the browser cache and hard reset (Ctrl + F5).",
            ariaLabel: "Troubleshooting: clear the browser cache and hard reset with Control F5",
            iconProps: { iconName: "Refresh" },
            onClick: () => { closeTeachingBubble(); trackCustomEvents('ECIFWorkscopePortal.Help.dealAssistanceSupport', 'Deal Assistance support Button Click', 'Success'); },
          },
          { key: "daContactsHeader", itemType: ContextualMenuItemType.Header, text: "Contacts" },
          {
            key: "daEcif",
            text: "ECIF — agent install",
            ariaLabel: "ECIF agent install",
            iconProps: { iconName: "Link" },
            href: "https://aka.ms/ECIFAgentInstall",
            target: "_blank",
            onClick: () => { closeTeachingBubble(); trackCustomEvents('ECIFWorkscopePortal.Help.dealAssistanceSupport', 'Deal Assistance support Button Click', 'Success'); },
          },
          {
            key: "daAco",
            text: "Azure Credit Offer — ACOHelp@microsoft.com",
            ariaLabel: "Email Azure Credit Offer support at ACOHelp@microsoft.com",
            iconProps: { iconName: "Mail" },
            href: "mailto:ACOHelp@microsoft.com",
            onClick: () => { closeTeachingBubble(); trackCustomEvents('ECIFWorkscopePortal.Help.dealAssistanceSupport', 'Deal Assistance support Button Click', 'Success'); },
          },
          {
            key: "daAza",
            text: "Azure Access — AAPoc@microsoft.com",
            ariaLabel: "Email Azure Access support at AAPoc@microsoft.com",
            iconProps: { iconName: "Mail" },
            href: "mailto:AAPoc@microsoft.com",
            onClick: () => { closeTeachingBubble(); trackCustomEvents('ECIFWorkscopePortal.Help.dealAssistanceSupport', 'Deal Assistance support Button Click', 'Success'); },
          },
          {
            key: "daDealDesk",
            text: "Deal Desk Investments — dsupport@microsoft.com",
            ariaLabel: "Email Deal Desk Investments support at dsupport@microsoft.com",
            iconProps: { iconName: "Mail" },
            href: "mailto:dsupport@microsoft.com",
            onClick: () => { closeTeachingBubble(); trackCustomEvents('ECIFWorkscopePortal.Help.dealAssistanceSupport', 'Deal Assistance support Button Click', 'Success'); },
          },
        ],
      },
    },
    {
      key: "Whats New",
      text: intl.formatMessage(messages.whatsNew),
      ariaLabel: intl.formatMessage(messages.whatsNew),
      iconProps: { iconName: "whatsNew" },
      onClick: handleWhatsNewClicked
    },
    // Temporarily hidden per request (2026-07-31) — keep for possible re-enable later.
    // Note: the Guided Tour (TeachingBubbleMultiStep) is not currently mounted, so this
    // item is inert until that component is wired up.
    // {
    //   key: "Guided Tour",
    //   text: intl.formatMessage(messages.guidedTour),
    //   ariaLabel: intl.formatMessage(messages.guidedTour),
    //   iconProps: { iconName: "guided-tour" },
    //   onClick: () => {
    //     showGuidedTour();
    //     trackHelpMenuOptionClicks('guidedTour');
    //   },
    // },
    {
      key: "roadmap",
      text: intl.formatMessage(messages.roadmap),
      ariaLabel: intl.formatMessage(messages.roadmap),
      iconProps: { iconName: "roadmap" },
      href: "https://aka.ms/ecifwsroadmap",
      target: "https://aka.ms/ecifwsroadmap",
      onClick: () => { closeTeachingBubble(); trackHelpMenuOptionClicks('roadmap'); },
    },
    {
      key: "privacyNotice",
      text: intl.formatMessage(messages.privacyNotice),
      ariaLabel: intl.formatMessage(messages.privacyNotice),
      iconProps: { iconName: "privacy-notice" },
      href: "https://aka.ms/dpn",
      target: "https://aka.ms/dpn",
      onClick: () => { closeTeachingBubble(); trackHelpMenuOptionClicks('privacyNotice'); }
    },
    {
      key: "walkingDeck",
      text: intl.formatMessage(messages.walkingDeck),
      ariaLabel: intl.formatMessage(messages.walkingDeck),
      iconProps: { iconName: "walking-deck" },
      href: "https://aka.ms/WorkscopeWalkingDeck",
      target: "https://aka.ms/WorkscopeWalkingDeck",
      onClick: () => { closeTeachingBubble(); trackHelpMenuOptionClicks('walkingDeck'); }
    },
  ], [intl, trackHelpMenuOptionClicks, trackCustomEvents, closeTeachingBubble, handleWhatsNewClicked, showGuidedTour]);



  const handleSignOut = useCallback(() => {
    trackCustomEvents('ECIFWorkscopePortal.profile.signout', 'Sign out Button Click', 'Success');
    context.authClient.logOut();
  }, [context, trackCustomEvents]);

  const ocvOptions: IFeedbackInitOptions = useMemo(() => ({
    appId: parseInt(process.env.REACT_APP_OCV_APP_ID),
    clientName: 'ECIFWorkscope',
    isProduction: process.env.REACT_APP_IS_PROD === 'true' ? true : false,
    authenticationType: FeedbackAuthenticationType.AAD,
    //ageGroup: FeedbackAgeGroup.Adult,
    callbackFunctions: {

    },
    width: 4000,
    telemetryId: process.env.REACT_APP_INSTRUMENTATION_KEY,
    userId: user.oid,
    tenantId: '72f988bf-86f1-41af-91ab-2d7cd011db47',
    feedbackUiType: FeedbackUiType.SidePane,
    hostPlatform: FeedbackHostPlatformType.Web,
    feedbackConfig: {
      isSupportEnabled: false,
      isDisplayed: true,
      isEmailCollectionEnabled: true,
      isFileUploadEnabled: true,
      isFeedbackForumEnabled: true,
      isMyFeedbackEnabled: true,
      isScreenshotEnabled: true,
      isScreenRecordingEnabled: true,
      feedbackForumUrl: 'https://aka.ms/EcifwsMakeSuggestion',
      myFeedbackUrl: process.env.REACT_ECIF_APP,
      privacyUrl: 'https://privacy.microsoft.com/en-us/privacystatement',
      complianceChecks: {
        // connectedExperiences: FeedbackPolicyValue.Enabled,
        policyAllowContact: FeedbackPolicyValue.Enabled,
        policyAllowContent: FeedbackPolicyValue.Enabled,
        policyAllowFeedback: FeedbackPolicyValue.Enabled,
        policyAllowScreenshot: FeedbackPolicyValue.Enabled,
        policyAllowSurvey: FeedbackPolicyValue.Enabled,
        // policyEmailCollectionDefault: FeedbackPolicyValue.Enabled,
        policyScreenshotDefault: FeedbackPolicyValue.Enabled,
        // policyContentSamplesDefault: FeedbackPolicyValue.Enabled,
      },
      email: user.email
    },
    themeOptions: { baseTheme: theme.name === 'dark' ? CoherenceV9DarkTheme : CoherenceV9LightTheme }
  }), [user, theme]);

  ocvOptions.callbackFunctions!.onDismiss = useCallback((_isFeedbackSent?: boolean) => {
    closePanel();
  }, [closePanel]);

  // Profile Center
  const profileProps = useMemo(() => ({
    // Changes made by Manideep Kalavala - 2026-07-31 - Task 16413955: avoid a duplicate tab stop inside the profile button.
    persona: {
      imageUrl: '',
      text: user.name,
      tertiaryText: user.email,
      className: classes.profilePersona
    },
    actions: [
      // {
      //   children: 'Sign out',
      //   onClick: handleSignOut,
      //   'aria-label': 'Sign out',
      // }
    ]
  }), [user]);

  const renderResourcesFooterContent = useCallback(() => <PrimaryButton
  onClick={() => {
    setIsResourcePanelOpen(false);
    trackCustomEvents('ECIFWorkscopePortal.Resources.close', 'Resources Panel Close Button Clicked', 'Success');
  }}>Close</PrimaryButton>, [setIsResourcePanelOpen, trackCustomEvents]);


  const closeKnowMoreSection = useCallback(() => {
    const ele = document.getElementById('drawer-close-icon-button');
    ele && ele?.click();
  }, []);

  const closeOtherPanels = useCallback(() => {
    settingsPanelRef.current?.dismiss();
    feedbackCenterRef.current?.dismiss();
    profileCenterRef.current?.dismiss();
    closeKnowMoreSection();
  }, [settingsPanelRef, feedbackCenterRef, profileCenterRef, closeKnowMoreSection]);

  useEffect(() => {
    if (externalMessage.enabled && typeof externalMessage?.handleSendMessage == "function" && !externalMessage?.isSupportTicketClicked) {
      const tpid = document.getElementById('trigger-copilot-portal-repo')?.getAttribute('data-tpid');
      const prompt = copilotConfig.CopilotCustomerYield.replace('[TPID]', tpid);
      externalMessage?.handleSendMessage(prompt);
      trackCustomEvents('ECIFWorkscope.CopilotFlyoutOpened', 'Customer ECIF Yield Button Click', 'Success', { 
        TPID: tpid,
      });
      setExternalMessage((prevState) => {
        return {
          ...prevState,
          enabled: false,
        }
      });
    }
   
  }, [externalMessage?.isInit, externalMessage.enabled]);
  const openCopilotFlyout = useCallback(() => {
    closeOtherPanels();
    isResourcePanelOpen && setIsResourcePanelOpen(false);
    setIsBotOpen(() => true);

    // We need 1 sec gap after the copilot flyout is opened so that it can be initialized properly
    // This will help in showing the copilot loader
    setTimeout(() => {
      setExternalMessage((prevState) => {
      return {
        ...prevState,
        enabled: true,
      }
    });
    }, 1000);
  }, [setExternalMessage, externalMessage, closeOtherPanels, isResourcePanelOpen, setIsResourcePanelOpen, setIsBotOpen, window.location.pathname]);

    const openResourceFlyout = useCallback(() => {
    closeOtherPanels();
    // If copilot is open, close it
    isBotOpen && setIsBotOpen(false);
    // open the resource panel
    setIsResourcePanelOpen(() => true);
  }, [closeOtherPanels, isBotOpen, setIsResourcePanelOpen, setIsBotOpen, window.location.pathname]);

  useEffect(() => {
    window.addEventListener('resourceOptionEvent', openResourceFlyout);
 
    return () => {
      window.removeEventListener('resourceOptionEvent', openResourceFlyout);
    };
  }, [openResourceFlyout]);
  useEffect(() => {
    window.addEventListener('ceyEvent', openCopilotFlyout);
 
    return () => {
      window.removeEventListener('ceyEvent', openCopilotFlyout);
    };
  }, [openCopilotFlyout]);

  const chatBotIcon = useCallback(() => (
    <img
      src={coloredCopilot}
      alt="Copilot"
      style={{ width: "20px", height: "20px" }}
    />
  ), []);

  const helpIcon = useCallback(() => (
    <Icon iconName="Help" style={{ color: 'white', fontSize: 16 }} />
  ), []);

  const resourcesIcon = useCallback(() => (
    <DocumentArrowDown20Regular color='white'/>
  ), []);


  const { onReduceData, onGrowData, onRenderData } = useResizeGroup({ closePanel, currentPanel });


  const yourCloseBotFunction = useCallback(() => {
      if (window.location.href.includes('dashboard')) {
          const headerAppName = document.getElementById('header-app-name');
          const homeHeader = document.querySelector('h1');
          const createWorkscopeSpan = Array.from(document.querySelectorAll('span')).find(span => span.textContent === 'Create Workscope');

          if (headerAppName && homeHeader && homeHeader.textContent === 'Home' && createWorkscopeSpan) {
              headerAppName.focus();
          }
          setIsBotOpen(false);
      } else {
          setIsBotOpen(false);
      }
      trackCustomEvents('ECIFWorkscopePortal.CSTCopilot', 'CSTCopilot Close button clicked', 'Success');
  }, [setIsBotOpen, trackCustomEvents, window?.location?.href]);

    const additionalContextDetails = useMemo(() => {
        return {
            pageLocation: window.location.href,
            sourceName: agentSourceName
        };
    }, [window.location.href]);


  const positiveFeedback = useCallback(() => {
    trackCustomEvents('ECIFWorkscopePortal.CSTCopilot', 'CSTCopilot Positive Feedback button clicked', 'Success');
  }, [trackCustomEvents]);

  const negativeFeedback = useCallback(() => {
    trackCustomEvents('ECIFWorkscopePortal.CSTCopilot', 'CSTCopilot Negative Feedback button clicked', 'Success');
  }, [trackCustomEvents]);

  useEffect(() => {
    //SGT (Start Guided Tour) - key in local storage to show/hide guided tour
    if (localStorage.getItem(lStorageKey.SGT) === null && isUserLoggedIn) {
      //This will enable guided tour pop up
      setHideTourPopup(false);
      setShouldSetTBData(true);
      const teachingBubble = {
        dashboard: false,
        ecifWorkscope: false,
      };
      localStorage.setItem(lStorageKey.TEACHING_BUBBLE, JSON.stringify(teachingBubble));
    }
  }, [isUserLoggedIn]);

  React.useEffect(() => {
    // Changes made by Vinay Reddy Vippala - 2026-07-14 - a11y: apply the two sanctioned Coherence-chrome patches
    // idempotently: (1) COHERENCE_LEFT_NAV role="none" (screen reader was reading the navigation landmark twice);
    // (2) WCAG 1.1.1 image-alt — the Coherence <Header> renders the brand logo <img id="HeaderLogo"> with no alt text
    // and exposes no logo-alt prop. Both target library-rendered nodes that mount asynchronously, so a one-shot lookup
    // races the render (the logo is often absent when this effect first runs — hence the FastPass image-alt still failing).
    // We apply immediately AND observe the DOM until both nodes exist, then disconnect. Idempotent + no visible/behaviour change.
    const applyCoherenceA11yPatches = (): boolean => {
      const coherenceLeftNav = document.getElementById('COHERENCE_LEFT_NAV');
      coherenceLeftNav && coherenceLeftNav.setAttribute('role', 'none');
      const headerLogo = document.getElementById('HeaderLogo') as HTMLImageElement | null;
      if (headerLogo && !headerLogo.getAttribute('alt')) {
        headerLogo.setAttribute('alt', intl.formatMessage(messages.headerLogoAlt));
      }
      // Changes made by Vinay Reddy Vippala - 2026-07-14 - a11y (WCAG 1.3.1 aria-required-children): the Coherence header
      // right-items region renders <div class="rightItemsContainer-*" role="menubar"> whose children are button[aria-haspopup],
      // NOT the menuitem/menuitemcheckbox/menuitemradio that role="menubar" requires — so FastPass flags aria-required-children.
      // Coherence exposes no prop to change this. We neutralise the invalid role to "none" ONLY when the container has no valid
      // menuitem children (so we never demote a correctly-populated menubar). Same sanctioned pattern as the left-nav fix; the
      // child buttons stay focusable + labelled, so no keyboard/behaviour/visible change.
      document.querySelectorAll('[role="menubar"]').forEach((menubar) => {
        const hasMenuItemChild = menubar.querySelector('[role="menuitem"], [role="menuitemcheckbox"], [role="menuitemradio"]');
        if (!hasMenuItemChild) {
          menubar.setAttribute('role', 'none');
        }
      });
      // Done once the logo (the async-mounted node this guards) is present and named.
      return !!(headerLogo && headerLogo.getAttribute('alt'));
    };

    if (!applyCoherenceA11yPatches()) {
      const observer = new MutationObserver(() => {
        if (applyCoherenceA11yPatches()) {
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      // Safety valve: stop observing after 15s even if the logo never appears, so we never leak an observer.
      const stop = window.setTimeout(() => observer.disconnect(), 15000);
      localStorage.removeItem(intl.formatMessage(messages.competitiveBidProperty));
      return () => {
        observer.disconnect();
        window.clearTimeout(stop);
      };
    }

    localStorage.removeItem(intl.formatMessage(messages.competitiveBidProperty));
    return undefined;
  }, [window.location.pathname]);

  const focusToSignOutBtn = useCallback((event: React.KeyboardEvent<HTMLAnchorElement>) => {
    if (event.key === 'Tab') {
      event.preventDefault();
      signoutBtnRef.current?.focus(); // Focus to Sign Out button when user press tab key on Privacy Notice link
    }
  }, [signoutBtnRef]);

  const onSupportHelpClicked = useCallback((url) => {
    const width = window.screen.width * 0.75;
    const height = window.screen.height * 0.75;
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;

    window.open(url, "_blank", `width=${width},height=${height},left=${left},top=${top}`);
    trackCustomEvents('ECIFWorkscopePortal.CSTCopilot', 'CSTCopilot support help button clicked', 'Success', {
      link: url
    });
  }, [trackCustomEvents, window?.screen]);

  useEffect(() => {
    if (externalMessage.enabled && typeof externalMessage?.handleSendMessage == "function" && externalMessage?.isSupportTicketClicked && copilotConfig?.SupportTicketPrompt?.Enabled) {
      externalMessage?.handleSendMessage(copilotConfig?.SupportTicketPrompt?.Message);
      trackCustomEvents('ECIFWorkscope.CopilotSupportTicketPromptHit', 'Support ticket prompt hit on agent', 'Success', { 
        prompt: copilotConfig?.SupportTicketPrompt?.Message,
      });
      setExternalMessage((prevState) => {
        return {
          ...prevState,
          enabled: false,
          isSupportTicketClicked: false
        }
      });
    }
   
  }, [externalMessage?.isInit, externalMessage.isSupportTicketClicked, copilotConfig?.SupportTicketPrompt?.Enabled]);

  const onSupportTicketHelpClicked = useCallback((url) => {
    if(copilotConfig?.SupportTicketPrompt?.Enabled){
      setExternalMessage((prevState) => {
      return {
        ...prevState,
        enabled: true,
        isSupportTicketClicked: true
      }
    });
    trackCustomEvents('ECIFWorkscopePortal.CSTCopilot', 'CSTCopilot support help button clicked with prompt for support ticket', 'Success', {
      prompt: copilotConfig?.SupportTicketPrompt?.Message
    });
    }else{
      const width = window.screen.width * 0.75;
      const height = window.screen.height * 0.75;
      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;

      window.open(url, "_blank", `width=${width},height=${height},left=${left},top=${top}`);
      trackCustomEvents('ECIFWorkscopePortal.CSTCopilot', 'CSTCopilot support help button clicked', 'Success', {
        link: url
      });
    }
  }, [trackCustomEvents, window?.screen, copilotConfig?.SupportTicketPrompt?.Enabled]);


    
  const renderMCAPSChatBot = useCallback((): JSX.Element => {
    return (
      <CSTCopilot
        applicationName={intl.formatMessage(messages.copilotName)}
        applicationNameForCopilot={intl.formatMessage(messages.copilotName)}
        featureName={intl.formatMessage(messages.copilotName)}
        userName={user.email}
        theme={theme?.name === 'dark' ? 'dark' : 'light'}
        isCreateIncidentButtonVisible={process.env.REACT_APP_COPILOT_SUPPORT_TICKET_ENABLED === "true"}
        closeBot={() => yourCloseBotFunction()}
        positiveFeedback={() => positiveFeedback()}
        negativeFeedback={() => negativeFeedback()}
        isVisible={true}
        isTypewritingOn={false}
        //  isPromptCoachmarkVisible={true}
        isPromptButtonVisible={true}
        image={coloredCopilot}
        trackCustomEvents={trackCustomEvents}
        apiUrls={{ questionApi: process.env.REACT_APP_USE_DB_COPILOT === "true" ? process.env.REACT_APP_DB_COPILOT_URL : process.env.REACT_APP_CHATBOT_BASE_URL }}
        msalInstance={""}
        isCopyButtonVisible={true}
        isVersionVisible={true}
        appInsightConfig={{
          instrumentationKey: process.env.REACT_APP_INSTRUMENTATION_KEY,
        }}
        supportTicket={() => onSupportTicketHelpClicked(process.env.REACT_APP_MCAPS_URL)}
        botWelcomeMessage={copilotConfig.copilotWelcomeMessage}
        botSuggestionMessage={copilotConfig.copilotWelcomeSuggestion}
        promptsSuggestions={copilotConfig.copilotPromptsSuggestions}
        createSupportTicketButtonText={process.env.REACT_APP_COPILOT_SUPPORT_TICKET_BUTTON_TEXT}
        getBearerTokenCallback={() =>
          new Promise((resolve) => {
            const token = context.authClient.acquireToken(
              process.env.REACT_APP_ECIF_API_RESOURCE
            );
            return resolve(token);
          })
        }
        //pageInfo={window.location.href}
        additionalContextDetails={additionalContextDetails}
        VirtuosoCopilotErrorMessage={
          "Sorry the Copilot service is down right now. Please try again later."
        }
        textBoxLength={400}
        addionalHelpButtonSetting={{
          visible: process.env.REACT_APP_COPILOT_SUPPORT_HELP_ENABLED === "true",
          buttonText: process.env.REACT_APP_COPILOT_SUPPORT_HELP_BUTTON_TEXT
        }}
        additionalHelpButtonCallback={() => onSupportHelpClicked(process.env.REACT_APP_COPILOT_HELP_URL)}
        externalMessage={externalMessage}
        setExternalMessage={setExternalMessage}
        placeholderText={intl.formatMessage(messages.messageDeliveryAgent)}
        promptsToShow= {(() => {
            try {
                return JSON.parse(copilotConfig.copilotWelcomeSuggestion || "[]").length;
            } catch (e) {
                console.error("Failed to parse copilotPromptsSuggestions:", e);
                return 0;
            }
        })()}
        promptModalTitle={intl.formatMessage(messages.copilotPromptsSuggestionsTitle)}
        searchCharLimit={3}
        isSlashCommandEnabled={false}
        usedBy={intl.formatMessage(messages.usedByDisclaimer)}
      />
    );
  }, [yourCloseBotFunction, positiveFeedback, negativeFeedback, intl, user, theme, trackCustomEvents, context, copilotConfig, 
    onSupportHelpClicked, externalMessage, setExternalMessage, additionalContextDetails]);

  const onAppNameClick = useCallback(() => {
    //history.push({ pathname: `/${Pathname.DEALASSISTANCE}` });
    trackCustomEvents('ECIFWorkscopePortal.AppName', `App name ${appName} Clicked`, 'Success', { 
      link: `/${Pathname.DEALASSISTANCE}`
    });
  }, [appName, history, trackCustomEvents]);


  useEffect(() => {
    window.addEventListener('resourceOptionEvent', openResourceFlyout);
 
    return () => {
      window.removeEventListener('resourceOptionEvent', openResourceFlyout);
    };
  }, [openResourceFlyout]);
  useEffect(() => {
    window.addEventListener('ceyEvent', openCopilotFlyout);
 
    return () => {
      window.removeEventListener('ceyEvent', openCopilotFlyout);
    };
  }, [openCopilotFlyout]);

  const _items = useMemo(() => [
    {
      key: "chatBot",
      id: "header-chat-bot",
      text: "Chat with Copilot",
      ariaLabel: "Chat with Copilot",
      className: classes.headerButton,
      onRenderIcon: chatBotIcon,
      iconOnly: true,
      onClick: () => {
        closeOtherPanels();
        isResourcePanelOpen && setIsResourcePanelOpen(false);
        setIsBotOpen((isBotOpenState) => !isBotOpenState);
        trackCustomEvents('ECIFWorkscopePortal.ChatWithCopilot', 'Chat with Copilot Button Click', 'Success', { 
          isOpen: !isBotOpen
        });
      },
      checked: isBotOpen,
    },
    {
      key: "help",
      id: "header-help",
      text: intl.formatMessage(messages.customHelp),
      ariaLabel: intl.formatMessage(messages.customHelp),
      className: classes.headerButton,
      onRenderIcon: helpIcon,
      iconOnly: true,
      onClick: (e) => {
        e.stopPropagation();
         if (!isHelpMenuOpen) {
          setHelpMenuTarget(e.currentTarget);
        }
        isBotOpen && setIsBotOpen(false);
        // isHelpMenuOpen && closeTeachingBubble(); Because of this code, the teaching bubble was not going to the 6th step of feedback button on dashboard
        closeOtherPanels();
        settingsPanelRef.current?.dismiss();
        feedbackCenterRef.current?.dismiss();
        profileCenterRef.current?.dismiss();
        isResourcePanelOpen && setIsResourcePanelOpen(false);
        const OPEN_DELAY = 300;
        const anyPanelOpen =
        isResourcePanelOpen ||
        Boolean(currentPanel === settingsPanelRef) ||
        Boolean(currentPanel === feedbackCenterRef) ||
        Boolean(currentPanel === profileCenterRef);
        if (anyPanelOpen) {
         setTimeout(() => setIsHelpMenuOpen(true), OPEN_DELAY);
         trackCustomEvents('ECIFWorkscopePortal.Help', 'Help icon Button Click', 'Success', { 
            isOpen: true
          });
        } else {
          setIsHelpMenuOpen((isHelpMenuOpen) => !isHelpMenuOpen);
          trackCustomEvents('ECIFWorkscopePortal.Help', 'Help icon Button Click', 'Success', { 
            isOpen: !isHelpMenuOpen
          });
        }
      },
      checked: isHelpMenuOpen,
    },
    // {
    //   key: 'resources',
    //   onRenderIcon: resourcesIcon,
    //   ariaLabel: 'Resources',
    //   text: 'Resources',
    //   className: classes.headerButton,
    //   onClick: () => {
    //     closeOtherPanels();
    //     getTemplateVersion();
    //     setIsHelpMenuOpen(false);
    //     isBotOpen && setIsBotOpen(false);
    //     setIsResourcePanelOpen((isResourcePanelOpen)=>!isResourcePanelOpen);
    //     trackCustomEvents('ECIFWorkscopePortal.Resources', 'Resources Button Click', 'Success', { 
    //         isOpen: !isResourcePanelOpen
    //       });
    //   },
    //   checked: isResourcePanelOpen,
    // },
    // {
    //   key: 'settings',
    //   icon: 'Settings',
    //   iconProps: { iconName: 'Settings' },
    //   ariaLabel: 'Settings',
    //   className: classes.headerButton,
    //   text: 'Settings',
    //   onClick: () => {
    //     closeKnowMoreSection();
    //     isBotOpen && setIsBotOpen(false);
    //     isResourcePanelOpen && setIsResourcePanelOpen(false);
    //     setIsHelpMenuOpen(false);
    //     openPanel(settingsPanelRef);
    //     trackCustomEvents('ECIFWorkscopePortal.Settings', 'Settings Button Click', 'Success', { 
    //         isOpen: !Boolean(currentPanel === settingsPanelRef)
    //       });
    //   },
    //   checked: _.isEqual(currentPanel, settingsPanelRef),
    //   styles: {
    //     icon: {
    //       color: 'red !importent',
    //       background: 'green !importent'
    //     }
    //   }
    // },
    {
      key: 'feedback',
      id: "feedback-button",
      icon: 'Emoji2',
      iconProps: { iconName: 'Emoji2' },
      className: classes.headerButton,
      ariaLabel: 'Feedback',
      text: 'Feedback',
      checked: _.isEqual(currentPanel, feedbackCenterRef),
      onClick: () => {
        isBotOpen && setIsBotOpen(false);
        closeKnowMoreSection();
        isResourcePanelOpen && setIsResourcePanelOpen(false);
        setIsHelpMenuOpen(false);
        openPanel(feedbackCenterRef);
        trackCustomEvents('ECIFWorkscopePortal.Feedback', 'Feedback Button Click', 'Success', { 
            isOpen: !Boolean(currentPanel === feedbackCenterRef)
          });
      }
    }
  ], [classes.headerButton, intl, isBotOpen, setIsBotOpen, trackCustomEvents, closeOtherPanels, currentPanel, openPanel, closeTeachingBubble,
    isResourcePanelOpen, setIsResourcePanelOpen, isHelpMenuOpen, setIsHelpMenuOpen, getTemplateVersion, setHelpMenuTarget,
  settingsPanelRef, feedbackCenterRef, profileCenterRef, closeKnowMoreSection]);

 const formattedData = useMemo(() => ({
    primary: _items,
    overflow: []
  }), [_items]);

  useEffect(() => {
    reduxDispatch(setAppNavigationCollapsed(false));
  }, [reduxDispatch]);

  const profileCenterFooter = useCallback(() => {
        return (
          <>
            <button style={classes.linkStyle} onClick={handleSignOut} aria-label='Sign Out' ref={signoutBtnRef}>Sign out</button>
            <div style={{ padding: '15px', paddingTop: '0px' }} tabIndex={-1}>
              <a href={PRIVACY_LEGACY_URL} onClick={() => {
                trackCustomEvents('ECIFWorkscopePortal.profile.privacynotice', 'Privacy Notice Link Click', 'Success', { 
                  link: PRIVACY_LEGACY_URL
                });
              }} rel="noopener noreferrer" target="_blank" aria-label='Privacy Notice' onKeyDown={focusToSignOutBtn}>Privacy Notice</a>
            </div>
          </>
        )
      }, [handleSignOut, focusToSignOutBtn, signoutBtnRef, trackCustomEvents, classes]);

  return (
    <>
      <div role='banner'>
        <Header
          title={
            <TooltipHost content={appNameTooltip}>
              <div style={classes.headerTitleContainer}>
                <div
                  style={classes.appNameStyle}
                  id="header-app-name"
                  onClick={onAppNameClick}
                  tabIndex={0}
                  role='button'
                  aria-label={appName || ''}
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      onAppNameClick();
                    }
                  }}
                  >
                    {appName}
                  </div>
              </div>
            </TooltipHost>
          }
          showHamburger={false}
          isNavCollapsed={false}
          toggleNavCollapsed={() => {}}
          styles={{
            titleContainer: {
              color: 'white !important',
              marginLeft: '15px'
            }
          }}
        >
          <Template slot="collapsible-triggers">
            {/* <div style={{ flex: 1 }} /> */}
            <ResizeGroup
                styles={{ root: { background: 'transparent', height: '100%' } }}
                data={formattedData}
                onReduceData={onReduceData}
                onGrowData={onGrowData}
                onRenderData={onRenderData}
              />
          </Template>
          <Template slot="static-triggers">
            <div style={{ display: 'flex', alignItems: 'center' }}>
            <TooltipHost content={'Settings'} id={'settings'}>
              <HeaderButton
                onClick={() => {
                  closeKnowMoreSection();
                  isBotOpen && setIsBotOpen(false);
                  isResourcePanelOpen && setIsResourcePanelOpen(false);
                  setIsHelpMenuOpen(false);
                  openPanel(settingsPanelRef);
                  trackCustomEvents('ECIFWorkscopePortal.Settings', 'Settings Button Click', 'Success', {
                    isOpen: !Boolean(currentPanel === settingsPanelRef)
                  });
                }}
                checked={_.isEqual(currentPanel, settingsPanelRef)}
                iconProps={{ iconName: 'Settings' }}
                aria-describedby={'settings'}
                aria-labelledby={'settings'}
                aria-label='Settings'
                tabIndex={0}
                className={classes.headerButton}
                role='button'
              />
            </TooltipHost>
            <TooltipHost content={'profile'} id={'profile'}>
              <HeaderButton
                onClick={() => {
                  closeKnowMoreSection();
                  isBotOpen && setIsBotOpen(false);
                  isResourcePanelOpen && setIsResourcePanelOpen(false);
                  openPanel(profileCenterRef);
                  trackCustomEvents('ECIFWorkscopePortal.profile', 'Profile Button Click', 'Success', { 
                    isOpen: !Boolean(currentPanel === profileCenterRef)
                  });
                }}
                checked={_.isEqual(currentPanel, profileCenterRef)}
                aria-describedby={'profile'}
                aria-labelledby={'profile'}
                tabIndex={0}
                className={classes.headerButton}
                role='button'
                onKeyDown={e => {
                  if (e.key === 'Tab' && !e.shiftKey) {
                    const actionGridElement: HTMLElement = document.getElementById(intl.formatMessage(messages.alertActions));
                    const filterElement: HTMLElement = document.getElementById(intl.formatMessage(messages.dropdownfilter));
                    if (actionGridElement) {
                      actionGridElement.focus();
                    }
                    else if (filterElement) {
                      filterElement.focus();
                    }
                   }
                }}
              >
                <Persona hidePersonaDetails={true} size={PersonaSize.size28} {...profileProps.persona} />
              </HeaderButton>
            </TooltipHost>
            </div>
          </Template>
        </Header>
      </div>
      <>
      {isUserLoggedIn && isBotOpen && renderMCAPSChatBot()}
        {(showWhatsNew || !hideDialog) && (
          <WhatsNew
            filteredAnnouncements={filteredAnnouncements}
            hideDialog={hideDialog}
            toggleHideDialog={toggleHideDialog}
            openedThroughMenu={openedThroughMenu}
            title={announcementJsondata?.title ?? ''}
            subText={announcementJsondata?.subTitle ?? ''}
            triggerTeachingBubble={() => { }}
          />
        )}
        <ProfileCenter
          componentRef={profileCenterRef}
          isLightDismiss={true}
          onDismiss={() => {
            closePanel();
            trackCustomEvents('ECIFWorkscopePortal.profile.close', 'profile Panel Close Button Clicked', 'Success');
          }}
          {...profileProps}
          onRenderFooter={profileCenterFooter}

        />
        <FeedbackCenter
          componentRef={feedbackCenterRef}
          onDismiss={() => {
            closePanel();
            trackCustomEvents('ECIFWorkscopePortal.Feedback.close', 'Feedback Panel Close Button Clicked', 'Success');
          }}
          ocvOptions={ocvOptions}
          isOpen={Boolean(currentPanel === feedbackCenterRef)}
        />
        <Panel
          componentRef={settingsPanelRef}
          onDismiss={() => {
            closePanel();
            trackCustomEvents('ECIFWorkscopePortal.Settings.close', 'Settings Panel Close Button Clicked', 'Success');
          }}
          isOpen={Boolean(currentPanel === settingsPanelRef)}
          isLightDismiss={true}
          headerText="Settings"
          onOuterClick={(_e) => { }}
          closeButtonAriaLabel='Close Settings'
        >
          <Settings onDismissPanel={closePanel} />
        </Panel>
        <ContextualMenu
          items={helpSubMenuItems}
          hidden={!isHelpMenuOpen}
          target={helpMenuTarget}
          onDismiss={() => setIsHelpMenuOpen(false)}
          directionalHint={DirectionalHint.bottomRightEdge}
          calloutProps={{ preventDismissOnResize: true }}
        />
      </>
    </>

  );
};

export const AppHeader = withRouter(injectIntl(AppHeaderComponent));

// Generated by GitHub Copilot | author: Vinay Reddy Vippala | Updated on: 2026-07-14 | ~45 lines modified | a11y: Coherence header host-chrome patches — set header logo alt (WCAG 1.1.1) + neutralize childless [role=menubar] to role=none (WCAG 4.1.2 aria-required-children), MutationObserver-driven, re-applied on route change.
// Generated by GitHub Copilot | author: Manideep Kalavala | Updated on: 2026-07-31 | ~38 lines modified | Task 16413955: collapsed Profile-to-nav-to-main focus handoff across portal routes.
// Generated by GitHub Copilot | Updated on: 2026-10-06 | Removed the left navigation while preserving the top header.

